import { reactive } from "@vue/composition-api";
import { BusinessLoginState } from "./types";

export default function stateFactory(): BusinessLoginState {
    const state: BusinessLoginState = {
        businessId: null,
        operation: null,
        addonId: null,
        language: null,
        isLoading: false,
        error: null
    }
    return reactive(state);
}
